import React from "react";

const Footer = () => {
  return (
    <div className="footer position-relative">
      <div className="footer_main container">
        <div className="">
          <div className="footer_heading">
            <img src="/img/logo.webp" alt="logo" className="footer_logo" />
          </div>

          <ul className="footer_campany_details dm-sans">
            <li>
              Lorem is the place where everyone can is able to find some
              clothing
            </li>
            <li>
              <a href="tel:6786787678">+91 6786787678</a>
            </li>
            <li>
              <a href="mailto:info@gmail.com">info@gmail.com</a>
            </li>
            <li>Comapny Name</li>
            <li>Lorem is the place where everyone</li>
          </ul>
        </div>
        <div className="footer-about">
          <div className="footer_heading">
            <h2 className="dc-script">Information</h2>
          </div>
          <ul className="footer_campany_details dm-sans">
            <li>
              <a href="">About Us</a>
            </li>
            <li>
              <a href="">Privacy Policy</a>
            </li>
            <li>
              <a href="">Terms and Conditions</a>
            </li>
            <li>
              <a href="">Returns & Refund Policy</a>
            </li>
            <li>
              <a href="">Shipping policy</a>
            </li>
            <li>
              <a href="">Cancellation policy</a>
            </li>
            <li>
              <a href=""> Cookie Policy</a>
            </li>
          </ul>
        </div>
        <div className="footer-contact-info">
          <div className="footer_heading">
            <h2 className="dc-script">Categories</h2>
          </div>
          <ul className="footer_campany_details dm-sans">
            <li>
              <a href="">Sweet Tooth</a>
            </li>
            <li>
              <a href="">Tea, Coffee & Health Drinks</a>
            </li>
            <li>
              <a href="">Dairy, Bread & Eggs</a>
            </li>
            <li>
              <a href="">Breakfast & Instant Food</a>
            </li>
            <li>
              <a href="">Atta, Rice & Dal</a>
            </li>
            <li>
              <a href="">Cleaning Essentials</a>
            </li>
          </ul>
        </div>
        <div className="footer-my-account">
          <div className="footer_heading">
            <h2 className="dc-script">My Account</h2>
          </div>
          <ul className="footer_campany_details dm-sans">
            <li>
              <a href="">My Profile</a>
            </li>
            <li>
              <a href="">Wishlist</a>
            </li>
            <li>
              <a href="">Compare</a>
            </li>
            <li>
              <a href="">Orders</a>
            </li>
            <li>
              <a href="">Contact Us</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
